var _g, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgBnbIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4564_1825)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.0197 11.9444C24.0302 14.3174 23.3361 16.6402 22.0252 18.6192C20.7143 20.5981 18.8455 22.1442 16.6551 23.0619C14.4647 23.9797 12.0511 24.2279 9.71951 23.7752C7.38792 23.3224 5.24307 22.1891 3.55619 20.5184C1.86931 18.8478 0.716167 16.7149 0.242592 14.3895C-0.230984 12.0641 -0.00372363 9.65061 0.895633 7.45424C1.79499 5.25787 3.32605 3.37728 5.29519 2.05028C7.26433 0.723282 9.58312 0.00947824 11.9583 -0.000862489C15.1432 -0.0147283 18.2032 1.23597 20.4651 3.47612C22.727 5.71626 24.0057 8.76237 24.0197 11.9444Z",
    fill: "#F0B90B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.99056 6.79756L11.9522 4.5L15.9138 6.79756L14.4573 7.64633L11.9522 6.19756L9.44705 7.64633L7.99056 6.79756ZM15.9138 9.69511L14.4573 8.84634L11.9522 10.2951L9.44705 8.84634L7.99056 9.69511V11.3927L10.4957 12.8414V15.739L11.9522 16.5878L13.4087 15.739V12.8414L15.9138 11.3927V9.69511ZM15.9138 14.2902V12.5927L14.4573 13.4414V15.139L15.9138 14.2902ZM16.9479 14.8902L14.4428 16.339V18.0366L18.4044 15.739V11.1439L16.9479 11.9927V14.8902ZM15.4914 8.24634L16.9479 9.09511V10.7927L18.4044 9.94389V8.24634L16.9479 7.39756L15.4914 8.24634ZM10.4957 16.9537V18.6512L11.9522 19.5L13.4087 18.6512V16.9537L11.9522 17.8024L10.4957 16.9537ZM7.99056 14.2902L9.44705 15.139V13.4414L7.99056 12.5927V14.2902ZM10.4957 8.24634L11.9522 9.09511L13.4087 8.24634L11.9522 7.39756L10.4957 8.24634ZM6.95648 9.09511L8.41297 8.24634L6.95648 7.39756L5.5 8.24634V9.94389L6.95648 10.7927V9.09511ZM6.95648 11.9927L5.5 11.1439V15.739L9.4616 18.0366V16.339L6.95648 14.8902V11.9927Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4564_1825"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBnbIcon);
export default __webpack_public_path__ + "static/media/bnb-icon.09542fcb31160f7bfdd3ae8f1307c4ae.svg";
export { ForwardRef as ReactComponent };